module.exports = __webpack_public_path__ + "static/hxouselogo-620875d2dc5afc8b2bf60b6af338345b.png";